import type { Country } from '../../model';

export const COUNTRIES: Country[] = [
  {
    code: 'RU',
    name: 'Россия',
    dialCode: '+7',
    minLength: 10,
    format: '(###) ###-##-##',
    mask: '_',
  },
  {
    code: 'BY',
    name: 'Беларусь',
    dialCode: '+375',
    minLength: 9,
    format: '(##) ###-##-##',
    mask: '_',
  },
  {
    code: 'AZ',
    name: 'Азербайджан',
    dialCode: '+994',
    minLength: 9,
    format: '(##) ###-##-##',
    mask: '_',
  },
  {
    code: 'AM',
    name: 'Армения',
    dialCode: '+374',
    minLength: 8,
    format: '(##) ###-###',
    mask: '_',
  },
  {
    code: 'KZ',
    name: 'Казахстан',
    dialCode: '+7',
    minLength: 10,
    format: '(###) ###-##-##',
    mask: '_',
  },
  {
    code: 'KG',
    name: 'Кыргызская Республика',
    dialCode: '+996',
    minLength: 9,
    format: '(###) ###-###',
    mask: '_',
  },
  {
    code: 'MD',
    name: 'Молдова',
    dialCode: '+373',
    minLength: 8,
    format: '(##) ###-###',
    mask: '_',
  },
  {
    code: 'TJ',
    name: 'Таджикистан',
    dialCode: '+992',
    minLength: 9,
    format: '(##) ###-##-##',
    mask: '_',
  },
  {
    code: 'UZ',
    name: 'Узбекистан',
    dialCode: '+998',
    minLength: 9,
    format: '(##) ###-##-##',
    mask: '_',
  },
];
